import { NominationRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardNominationRefs: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<NominationRef[]> = (fetchContext, awardId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/awards/${awardId}/nomination-refs`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<NominationRef[]>(fetchContext.errorStore, response, 'get award nomination refs'));
